import { ReactTFC } from "../../../../../../utils/fp/missing-ts-parts";
import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import { SwarovskiDropdown } from "../../shared/SwarovskiDropdown";
import { CSS_COLORS } from "../../../../../../styles/styles-css-variables";
import { SwarovskiButton } from "../../../../../../components/_shared-components/ui-elements/SwarovskiButton";
import { fontSize } from "../../../../../../styles/fonts";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../../../../components/T";

export const IssuersExtension: ReactTFC<{
  environment: "test" | "live";
  issuers: Array<{
    id: string;
    name: string;
  }>;
  selected: {
    id: string;
    name: string;
  } | null;
  onChange: (id: string) => void;
  editLabel: string | TranslatedValue;
}> = ({ selected, issuers, onChange, editLabel }) => {
  const [selectedScreen, setSelectedScreen] = useState(selected);

  return !selectedScreen ? (
    <div>
      <SwarovskiDropdown
        attachStyles={css`
          width: 100%;
          height: 58px;
          outline: none;

          font-size: inherit;
          font-family: inherit;
          font-weight: inherit;
          letter-spacing: inherit;
          background: transparent;
        `}
        selected={
          selected
            ? {
                label: selected.name,
                value: selected.id,
              }
            : null
        }
        emptyLabel={`Select`}
        name={"state"}
        onChange={id => {
          onChange(id);
        }}
        options={issuers.map(i => ({ label: i.name, value: i.id }))}
      />
    </div>
  ) : (
    <div>
      <span className={"u-fw-300"} css={fontSize.x25}>
        {selectedScreen.name}
      </span>

      <div
        css={css`
          margin-top: 20px;

          display: flex;
          justify-content: flex-end;

          color: ${CSS_COLORS.Green};
        `}
      >
        <SwarovskiButton variant={"plain-underline"} as={"button"} onClick={() => setSelectedScreen(null)}>
          <T>{editLabel}</T>
        </SwarovskiButton>
      </div>
    </div>
  );
};
